import "../../../../../css/ui/table/waitListTable.css";

export default function WaitListTable(props) {

	return (
		<table className="fd" border={1} cellPadding="1" cellSpacing="1">
			<thead>
				<tr className="clr_river row">
					<th className="col-6">Position</th>
					<th className="col-6">Player</th>
				</tr>
			</thead>
			<tbody>
				{(() => {
					let i = 0,
						cnt = props.data.length,
						rows = [];
					for (i; i < cnt; i++) {
						rows.push(
							<tr key={i} className="row">
								<td className="col-6">{props.data[i].id}</td>
								<td className="col-6">{props.data[i].name}</td>
							</tr>
						);
					}
					return rows;
				})()}
			</tbody>
		</table>
	);
};